export const mergeArraysAndSortByYear = (entity, newEntity) => {
  return [...(entity ?? []), ...(newEntity ?? [])]
    .sort((a, b) => a.year - b.year);
};